<template>
	<div class="menu-item-picker" @click="createConfigurationField">
		<ExportTextToParamSvg />
	</div>
</template>

<script>
import { createConfigurationFieldForSelectedWorkflow } from '@/store/modules/selectedWorkflow/modules/configurations/actions';
import ExportTextToParamSvg from './assets/ExportTextToParamSvg.vue';
import { mapActions, mapGetters } from 'vuex';
import { CONFIGURATIONS_FIELDS_KEY } from '@/utils/workflow-node.const';
import { rootNode } from '@/store/modules/selectedWorkflow/getters';
import ParamsService from '@/utils/ParamsService';

export default {
	name: 'TextToConfigurationFieldFormatting',
	components: {
		ExportTextToParamSvg,
	},
	props: {
		editor: { type: Object },
	},
	computed: {
		...mapGetters([rootNode.fullPath]),
	},
	methods: {
		...mapActions([createConfigurationFieldForSelectedWorkflow.fullPath]),
		async createConfigurationField() {
			const { view, state } = this.editor;
			const { from, to } = view.state.selection;
			const text = state.doc.textBetween(from, to, '');
			const field = await this[createConfigurationFieldForSelectedWorkflow.fullPath]({ fieldValue: text });
			const param = ParamsService.buildKeyForPath(this[rootNode.fullPath], CONFIGURATIONS_FIELDS_KEY, field.id);
			this.saveTag(param);
		},
		saveTag(param) {
			const state = this.editor.state;
			this.editor
				.chain()
				.command(({ tr }) => {
					const newNode = state.schema.text(param);
					tr.replaceSelectionWith(newNode);
					return true;
				})
				.run();
		},
	},
};
</script>

<style lang="scss" scoped></style>
